import { connect } from 'react-redux';
import * as url from 'url';

import { IAppState } from '../../../../common/state';
import { HeaderNewbuilding } from '.';

export const HeaderNewbuildingContainer = connect((state: IAppState) => {
  const urlPath = url.parse(state.results.fullUrl).path;

  return {
    breadcrumbs: state.breadcrumbs,
    seoTitle: (urlPath && !urlPath.startsWith('/cat.php') && state.results.seo.h1) || undefined,
    newbuildingInfo: state.results.newbuildingInfo,
    roomType: (state.results.jsonQuery.room && state.results.jsonQuery.room.value) || [],
    isFromDeveloper: (state.results.jsonQuery.from_developer && state.results.jsonQuery.from_developer.value) || false,
  };
})(HeaderNewbuilding);
